import { motion } from 'framer-motion'
import { MdArrowBackIos } from 'react-icons/md'
import { Button } from '@nextui-org/react'
import { PrivateRoutes } from '@/constants/routes'
import { useNavigate, useParams } from 'react-router-dom'
import ListTable from './components/ListTable'

const ContributionsPage = () => {
  const navigate = useNavigate()
  const { slug } = useParams()

  return (
    <motion.div
      initial={{ y: 10, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: -10, opacity: 0 }}
      transition={{ duration: 0.3 }} className='space-y-4'
    >
      <div className='grid grid-cols-2'>
        <div className='flex items-center'>
          <Button
            variant='ghost' size='sm' color='primary' onClick={() => navigate(PrivateRoutes.HOME.replace(':slug', String(slug)))} startContent={
              <MdArrowBackIos className='text-black/50 mb-0.5 dark:text-white/90 text-slate-400 pointer-events-none flex-shrink-0' />
        }
          >Volver
          </Button>
          <h1 className='font-black md:text-2xl ml-2'>Listado de incentivos</h1>
        </div>
        <div className='flex items-center justify-end'>
          <Button
            variant='solid'
            size='sm'
            color='primary'
            onClick={() => navigate(PrivateRoutes.CONTRIBUTION.replace(':slug', String(slug)).replace(':id', 'new'))}
          >Crear campaña
          </Button>
        </div>
      </div>
      <div className='bg-white rounded-2xl shadow-md p-2 mt-4'>
        <ListTable />
      </div>
    </motion.div>
  )
}

export default ContributionsPage
